import React from 'react';

import {
	ContextualInviteNudgeFlagLoadable,
	LIVE_PAGE_SOURCE,
} from '@confluence/contextual-invite-nudge-flag';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { useLivePageInviteNudgeStore } from './useLivePageInviteNudgeStore.tsx';

const LivePageInviteNudgeComponent = () => {
	const [{ hasLivePageChanges }] = useLivePageInviteNudgeStore();

	if (!hasLivePageChanges) {
		return null;
	}

	return <ContextualInviteNudgeFlagLoadable source={LIVE_PAGE_SOURCE} />;
};

export const LivePageInviteNudge: React.FC<{}> = withTransparentErrorBoundary({
	attribution: Attribution.CE_MAU,
})(LivePageInviteNudgeComponent);
